import React from 'react';
import CartIndividualItem from '../components/cart/common/CartIndividualItem';

const renderCartIndividualItem = (items, scope, isCheckout) => {
    return items.map((theItem, theIndex) => (
        <CartIndividualItem
            key={scope+"-"+theIndex}
            index={theIndex}
            item={theItem}
            scope={scope}
            isCheckout={isCheckout}
        />
    ));
};

export const hasCartItems = (cartItems) => {

    const {
        pizzas,
        fooditems,
        beverages,
        specials
    } = cartItems;

    if (pizzas.length > 0 || fooditems.length > 0 || specials.length > 0 || beverages.legnth > 0) {
        return true;
    }
    
    return false;
}

export const renderCartItems = (cartItems, isCheckout = false) => {

    const {
        pizzas,
        fooditems,
        addons,
        beverages,
        specials
    } = cartItems;

    // get the specials to render
    const renderSpecials = renderCartIndividualItem(specials, 'special', isCheckout);

    // get the pizzas to render
    const renderPizzas = renderCartIndividualItem(pizzas, 'pizza', isCheckout);

    // get the food items to render
    const renderFoodItems = renderCartIndividualItem(fooditems, 'fooditem', isCheckout);

    // get the beverages to render
    const renderBeverages = renderCartIndividualItem(beverages, 'beverage', isCheckout);

    // get the beverages to render
    const renderAddons = renderCartIndividualItem(addons, 'addon', isCheckout);

    return [renderSpecials, renderPizzas, renderFoodItems, renderBeverages, renderAddons];
}

